import React, { useEffect, useState } from "react";
import "./SignVtrPage.scss";
import moment from "moment";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { connect } from "react-redux";
import SignForm1 from "../../forms/SignForm1";
import SignForm2 from "../../forms/SignForm2";
import SignForm3 from "../../forms/SignForm3";
import SignVtrNav from "../../components/SignVtrNav";
import {
  dateTimeSavedToDisplay,
  getCurrentOpenTrip,
} from "../../constants/vtrTrip";
import { isTestUser } from "../../reducers/rootReducer";
import {
  checkTokenValid,
  login_request,
} from "../../constants/default_request";
import TripReviewRedirect from "../../components/TripReviewRedirect";
import { Navigate, useLocation } from "react-router-dom";
import TokenRenewLogin from "../../components/TokenRenewLogin";
import { SalesCombinedEncRow } from "../../constants/Sales";
import { getSpeciesName } from "../../constants/Catch";
import EffortValidDialog from "../../components/EffortValidation/EffortValidDialog";
import Spinner from "../../components/common/Spinner";
import CatchDialog from "./CatchDialog";

function SignVtrPage(props) {
  const location = useLocation();
  const { vtrTrip, auth, actions, helpText, error, validations } = props;
  const isTokenValid = checkTokenValid(auth);
  const [isSigned, setIsSigned] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [disabled, setDisable] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [isValidTrip, setIsValidTrip] = useState({
    dialogIdx: 0,
    status: true,
  });
  const [noEffortTrip, setNoEffortTrip] = useState(false);
  const [values, setValues] = useState({
    redirect_cancel: false,
    date_land: null,
    date_sail: null,
    display_date_land: null,
    display_date_sail: null,
    images: [],
    redirectTripReview: false,
  });

  const validateEffort = (trip) => {
    const { no_effort_trip_reason: reason, images: efforts } = trip;
    if (reason === "0") {
      if (efforts.length === 0) {
        setIsValidTrip({ status: false, dialogIdx: 0 });
        return false;
      } else {
        for (let effort of efforts.values()) {
          if (effort.catch.length === 0) {
            setIsValidTrip({ status: false, dialogIdx: 1 });
            return false;
          }
        }
      }
    }
    return true;
  };

  const handleSailDateChange = (date) => {
    if (date && date.hasOwnProperty("_d")) {
      const newDateTime = date._d;
      if (newDateTime !== "") {
        const dt = moment(newDateTime, "DD-MM-YYYY LT");
        const bDateTime = dt.format("YYMMDDHHmm");
        setValues({
          ...values,
          display_date_sail: newDateTime,
          date_sail: bDateTime,
        });
      } else {
        setValues({ ...values, display_date_sail: newDateTime, date_sail: "" });
      }
    }
  };

  const handleDateLandChange = (date) => {
    if (date && date.hasOwnProperty("_d")) {
      let newDateTime = date._d;
      if (newDateTime !== "") {
        const dt = moment(newDateTime, "DD-MM-YYYY LT");
        const bDateTime = dt.format("YYMMDDHHmm");
        setValues({
          ...values,
          display_date_land: newDateTime,
          date_land: bDateTime,
        });
      } else {
        setValues({ ...values, display_date_land: newDateTime, date_land: "" });
      }
    }
  };

  const dateLandNowHandler = (event) => {
    event.preventDefault();
    console.info(event.target);
    let d = moment();
    const format = "DD-MMM-YY LT";
    const date_land = d.format("YYMMDDHHmm");
    const display_date_land = d.format(format);
    setValues({ ...values, date_land, display_date_land });
  };

  const sailDateNowHandler = (event) => {
    event.preventDefault();
    console.info(event.target, values);
    let d = moment();
    const format = "DD-MMM-YY LT";
    const date_sail = d.format("YYMMDDHHmm");
    const display_date_sail = d.format(format);
    setValues({ ...values, date_sail, display_date_sail });
  };

  useEffect(() => {
    console.group("SignVtrPage_mount");

    let currentTrip = getCurrentOpenTrip(
      vtrTrip.allOpenTrips,
      location.state.trip_id
    );
    setIsLoaded(true);
    currentTrip.username = auth.username;
    if (currentTrip && currentTrip.date_sail) {
      let displayDateSail = dateTimeSavedToDisplay(currentTrip.date_sail);
      currentTrip.display_date_sail = displayDateSail;
    }
    if (currentTrip && currentTrip.date_land) {
      let displayDateLand = dateTimeSavedToDisplay(currentTrip.date_land);
      currentTrip.display_date_land = displayDateLand;
    }

    const speciesList = validations.validations.species;
    let allCatchSold = true;
    let sumCatch = [];
    let allCatch = [];
    let speciesDone = [];
    let catchSpecies = [];
    let salesSpecies = [];
    let allEfforts = currentTrip.images;
    let allSales = currentTrip.sales;
    let sumSales = [];

    if (allEfforts && Array.isArray(allEfforts)) {
      allEfforts.forEach((item) => {
        if (item.hasOwnProperty("catch")) {
          allCatch = allCatch.concat(item.catch);
        }
      });

      allCatch.forEach((item) => {
        if (item.species && Number(item.kept) > 0 && item.species !== "NC") {
          if (!catchSpecies.includes(item.species)) {
            sumCatch.push({
              species: item.species,
              kept: Number(item.kept),
              uom: item.uom,
            });
            catchSpecies.push(item.species);
          } else {
            sumCatch.forEach((scatch) => {
              if (scatch.species === item.species) {
                let newKept = Number(item.kept) + Number(scatch.kept);
                scatch.kept = newKept;
                return;
              }
            });
          }
        }
      });
    }

    if (allSales && Array.isArray(allSales)) {
      allSales.forEach((sale) => {
        if (sale.species && Number(sale.sold) > 0) {
          if (!salesSpecies.includes(sale.species)) {
            sumSales.push({
              species: sale.species,
              sold: Number(sale.sold),
              uom: sale.uom,
            });
            salesSpecies.push(sale.species);
          } else {
            sumSales.forEach((sSale) => {
              if (sSale.species === sale.species) {
                let newSold = Number(sale.sold) + Number(sSale.sold);
                sSale.sold = newSold;
                return;
              }
            });
          }
        }
      });
    }
    speciesDone = salesSpecies.concat(
      catchSpecies.filter((item) => salesSpecies.indexOf(item) < 0)
    );
    let combinedSum = [];
    speciesDone.forEach((item) => {
      let enc = new SalesCombinedEncRow();
      let currentCatch;
      sumCatch.forEach((sum) => {
        if (sum.species === item) {
          currentCatch = sum;
          return;
        }
      });
      let currentSale;
      sumSales.forEach((sale) => {
        if (sale && sale.hasOwnProperty("species") && sale.species === item) {
          currentSale = sale;
          return;
        }
      });

      if (currentCatch && currentSale) {
        enc.setSpecies(currentCatch.species);
        enc.setCatchUom(currentCatch.uom);
        enc.setAvailable(currentCatch.kept);
        enc.setSold(currentSale.sold);
        enc.setSalesUom(currentSale.uom);
        if (Number(currentCatch.kept) !== currentSale.sold) {
          allCatchSold = false;
        }
      } else if (currentCatch && !currentSale) {
        enc.setSpecies(currentCatch.species);
        enc.setCatchUom(currentCatch.uom);
        enc.setAvailable(currentCatch.kept);
        enc.setSold(0);
        enc.setSalesUom(currentCatch.uom);
        allCatchSold = false;
      } else {
        enc.setSpecies(currentSale.species);
        enc.setCatchUom(currentSale.uom);
        enc.setAvailable(0);
        enc.setSold(currentSale.sold);
        enc.setSalesUom(currentSale.uom);
        allCatchSold = false;
      }
      enc.setSpeciesLabel(getSpeciesName(enc.species, speciesList));
      combinedSum.push(enc);
    });
    currentTrip.allCatchSold = allCatchSold;
    currentTrip.combined_sales = combinedSum;
    // Evaluating if it's a PAPER VTR and assigning the value
    // of the lowest_serial_num to the current trip before submission.
    if (
      "submission_type" in currentTrip &&
      currentTrip.submission_type === "PAPER"
    ) {
      //The docid is written in trip_id, which we need to resubmitted for the new trip reports model
      currentTrip.docid = currentTrip.trip_id;
      if (
        "lowest_serial_num" in currentTrip &&
        currentTrip.lowest_serial_num !== undefined &&
        currentTrip.lowest_serial_num !== ""
      ) {
        currentTrip.trip_id = currentTrip.lowest_serial_num;
      }
    }
    // * validating no effort trip to handle back button issue
    setNoEffortTrip(currentTrip.no_effort_trip_reason !== "0");
    console.log("current trip", currentTrip);
    console.groupEnd();
    setValues(currentTrip);
    actions.resetTripRedirect();

    validateEffort(currentTrip);
  }, [
    actions,
    auth,
    location.state.trip_id,
    validations.validations.species,
    vtrTrip.allOpenTrips,
  ]);

  const _HandleClose = (event) => {
    event.preventDefault();
    setValues({
      ...values,
      redirectTripReview: true,
    });
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
      setValues({ ...values, redirect_cancel: true });
    }
  };

  const submitForm = (event, username, password) => {
    event.preventDefault();
    const payload = login_request(username, password);

    actions.login(payload, username, password);
    setValues({ ...values, password: "" });
  };

  const setPassword = (event, value) => {
    setValues({ ...values, password: value });
  };

  const handleChange = (event) => {
    // setValues({ ...values, isSigned: event.target.checked });
    setIsSigned(event.target.checked);
  };

  const handleBack = (event, value) => {
    event.preventDefault();
    if (value === "Back") {
      if (currentStep >= 2 && currentStep <= 3) {
        setCurrentStep(currentStep - 1);
      }
      // * if no effort trip should return to the initial page.
      if (noEffortTrip) {
        setCurrentStep(1);
      }
      if (disabled) {
        setDisable(false);
      }
    }
  };

  const handleNext = (event, value) => {
    event.preventDefault();
    if (currentStep === 1) {
      actions.updateTrip(values, auth.client_id, location.state.trip_id);
      actions.resetTripRedirect();
    }

    if (currentStep >= 1 && currentStep < 3) {
      //In case of no sales skip page 2 display of sales records
      if (
        currentStep === 1 &&
        (!values.hasOwnProperty("sales") ||
          !Array.isArray(values.sales) ||
          values.sales.length === 0)
      ) {
        setCurrentStep(currentStep + 2);
      } else {
        setCurrentStep(currentStep + 1);
      }
    }
    if (value === "Submit") {
      let isTokenValid = checkTokenValid(auth);
      if (!isTokenValid) {
        return;
      }
      if (isTokenValid) {
        actions.submitTrip(
          auth.client_id,
          auth.token,
          values,
          values.trip_id,
          isTestUser(auth.user_app_status)
        );
      }
      setDisable(true);
      setShowSpinner(true);
    }
  };

  if (
    (vtrTrip.redirect === true && values.redirect_cancel === true) ||
    values.redirectTripReview === true
  ) {
    return (
      <TripReviewRedirect
        trip_id={location.state.trip_id}
        client_id={auth.client_id}
      />
    );
  }

  if (vtrTrip.redirect === true && currentStep === 3) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/home`}
        state={{
          client_id: auth.client_id,
          user_full_name: auth.user_full_name,
        }}
      />
    );
  }

  if (!isTokenValid && isSigned) {
    return (
      <TokenRenewLogin
        submitForm={submitForm}
        password={values.password}
        setPassword={setPassword}
        logout={actions.logout}
      />
    );
  }

  if (values.allCatchSold === false) {
    return (
      <CatchDialog
        combined_sales={values.combined_sales}
        handleClose={_HandleClose}
      />
    );
  }
  if (!isValidTrip.status) {
    console.info("Got inside!");
    return (
      <EffortValidDialog
        msgIdx={isValidTrip.dialogIdx}
        handleClick={_HandleClose}
      />
    );
  }

  return (
    <div className="SignVtrPage" data-testid="SignVtrPage">
      <SignForm1
        currentStep={currentStep}
        isLoaded={isLoaded}
        helpText={helpText.helpText}
        handleSailDateChange={handleSailDateChange}
        display_date_sail={values.display_date_sail}
        sailDateNowHandler={sailDateNowHandler}
        handleLandDateChange={handleDateLandChange}
        display_land_date={values.display_date_land}
        landDateNowHandler={dateLandNowHandler}
      />
      <SignForm2 currentStep={currentStep} currentTrip={values} />
      <SignForm3
        currentStep={currentStep}
        isSigned={isSigned}
        handleChange={handleChange}
      />
      <SignVtrNav
        currentStep={currentStep}
        isSigned={isSigned}
        handleCancel={_cancel}
        handleNext={handleNext}
        handleBack={handleBack}
        isDisabled={disabled}
      />
      {showSpinner && Object.keys(error.error).length === 0 && <Spinner />}
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(SignVtrPage);
